var _circle, _circle2, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgComplete = function SvgComplete(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 80,
    viewBox: "0 0 211 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 106.5,
    cy: 40,
    r: 40,
    fill: "#008850"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.08,
    cx: 106.5,
    cy: 40,
    r: 36,
    fill: "#008850"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.879 31.814L116.582 28.5075C116.527 28.4525 116.462 28.4088 116.39 28.3791C116.318 28.3493 116.241 28.334 116.164 28.334C116.086 28.334 116.009 28.3493 115.937 28.3791C115.866 28.4088 115.8 28.4525 115.746 28.5075L101.82 42.4423C101.765 42.4973 101.7 42.5409 101.628 42.5707C101.557 42.6004 101.48 42.6157 101.402 42.6157C101.324 42.6157 101.248 42.6004 101.176 42.5707C101.104 42.5409 101.039 42.4973 100.984 42.4423L97.6869 39.1357C97.6321 39.0807 97.5669 39.0371 97.4952 39.0073C97.4235 38.9776 97.3466 38.9622 97.2689 38.9622C97.1912 38.9622 97.1143 38.9776 97.0426 39.0073C96.9709 39.0371 96.9057 39.0807 96.8509 39.1357L93.5537 42.4423C93.443 42.553 93.3809 42.7032 93.3809 42.8597C93.3809 43.0163 93.443 43.1665 93.5537 43.2772L100.984 50.7087C101.039 50.7637 101.104 50.8073 101.176 50.8371C101.248 50.8668 101.324 50.8822 101.402 50.8822C101.48 50.8822 101.557 50.8668 101.628 50.8371C101.7 50.8073 101.765 50.7637 101.82 50.7087L119.879 32.6407C119.987 32.5303 120.048 32.3819 120.048 32.2273C120.048 32.0728 119.987 31.9244 119.879 31.814Z",
    fill: "#008850"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 179.5,
    cy: 14,
    r: 2,
    fill: "#008850"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.5,
    cy: 26,
    r: 3,
    fill: "#008850"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 35,
    r: 3,
    fill: "#008850"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.5,
    cy: 54,
    r: 2,
    fill: "#008850"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.5,
    cy: 62,
    r: 2,
    fill: "#008850"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 26,
    r: 2,
    fill: "#008850"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 20,
    r: 2,
    fill: "#008850"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 45,
    r: 2,
    fill: "#008850"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 28,
    r: 2,
    fill: "#008850"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 45,
    r: 2,
    fill: "#008850"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 31,
    r: 1,
    fill: "#008850"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 50,
    r: 1,
    fill: "#008850"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.5,
    cy: 49,
    r: 1,
    fill: "#008850"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.5,
    cy: 33,
    r: 1,
    fill: "#008850"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.5,
    cy: 44,
    r: 1,
    fill: "#008850"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.5,
    cy: 22,
    r: 1,
    fill: "#008850"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 41,
    r: 1,
    fill: "#008850"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 17,
    r: 1,
    fill: "#008850"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgComplete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "complete.59ab4f34a5d435fe9cb304ad20b779b0.svg";